/** MUI Chip `color` for story list status (mirrors sleep-videos-v3 chip patterns). */
export const AI_STORIES_STATUS_CHIP = {
  creating: { label: 'Creating…', color: 'default' },
  queued: { label: 'Queued', color: 'info' },
  generating_plots: { label: 'Generating plot…', color: 'warning' },
  plots_generated: { label: 'Plot ready', color: 'info' },
  script_generating: { label: 'Generating script…', color: 'warning' },
  script_failed: { label: 'Script failed', color: 'error' },
  completed: { label: 'Completed', color: 'success' },
};

/** Same height/padding idea as PIPELINE_CHIP_SX in sleep-videos-v3/constants.js */
export const AI_STORIES_CHIP_SX = { height: 22, '& .MuiChip-label': { px: 1 } };

/** Default ElevenLabs `voice_id` for Bikers niche (VoiceOverConfig row in ai-stories scope). */
export const BIKERS_DEFAULT_VOICE_ID = 'alFofuDn3cOwyoz1i44T';

/** Sub-step labels while `status === 'script_generating'` (aligned with StoryScriptDetailPage). */
export const AI_STORIES_PROGRESS_STEP_LABELS = {
  'generating-plots': 'Generating plot',
  'choosing-plot': 'Starting generation',
  plot: 'Plot',
  synopsis: 'Synopsis',
  outline: 'Outline',
  characters: 'Characters',
  exporting: 'Exporting',
};

const CHAPTER_PROGRESS_STEP_RE = /^chapter-(\d+)$/;

/** Human-readable label for SSE / DB `progress.currentStep` (includes dynamic `chapter-N`). */
export function labelForAiStoriesProgressStep(stepId) {
  if (stepId == null || stepId === '') return '';
  const m = String(stepId).match(CHAPTER_PROGRESS_STEP_RE);
  if (m) return `Chapter ${m[1]}`;
  return AI_STORIES_PROGRESS_STEP_LABELS[stepId] ?? stepId;
}
